'use strict';

var hasImage = function(data) {

	return !!data.width;

};

var getLoader = function(data) {

	if (hasImage(data)) {

		return '<div class="image-grid__loader"></div>';

	}

	return '';

};

var getUrl = function(imageSize, data) {

	return data.baseUrl + data.sizes[imageSize] + data.ext;

};

var getLazyAttr = function(imageSize, data) {

	// Make sure this item has an image.
	if (hasImage(data)) {

		return ' data-lazy-image="' + getUrl(imageSize, data) + '"';

	}

	return '';

};

var getLinkClass = function(isLink) {

	if (isLink) {

		return ' image-grid__item--link';

	}

	return '';

};

var getDescription = function(isTextHidden, data) {

	// if (isTextHidden && data.description.length > 50) {

	// 	return data.description.substr(0, 50) + '...';

	// }

	return data.description;

};

var template = function(imageSize, data, options) {

	var t = '<div class="grid__cell image-grid__cell">' +
				'<div class="image-grid__item' + getLinkClass(data.isLink) + '" data-image-grid-index="' + data.index + '">' +
					'<div class="image-grid__image-wrapper">' +
						'<div class="image-grid__image"' + getLazyAttr(imageSize, data) + '></div>' +
						getLoader(data) +
					'</div>' +
					'<div class="image-grid__text-wrapper">' +
						'<div class="image-grid__title">' + data.title + '</div>' +
						'<div class="image-grid__desc">' + getDescription(options.isTextHidden, data) + '</div>' +
						options.customTextWrapperMarkupCallback(data) +
					'</div>' +
				'</div>' +
			'</div>';

	return t;

};

module.exports = {

	template: template,
	getUrl: getUrl

};
